import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Middleware = ({ children }) => {
  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user?.role !== "IVAR") {
      navigate("/login");
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
    }
  }, [user, navigate]);

  if (!user || user?.role !== "IVAR") return null;

  return <>{children}</>;
};

export default Middleware;
